"use strict";

import CrossPromotionModal from './product-detail/component/CrossPromotionModal';
import Css from './css';

/**
 * Handle add to cart functionality
 * Decides whether to use Ajax or traditional form submission based on cross-promotion presence
 */
const addToCart = function(formElement, submitButton, qtyInput) {
    // Check if cross-promotion content exists on the page
    const crossPromotionContent = CrossPromotionModal.detectCrossPromotion();
    
    if (!crossPromotionContent) {
        // No cross-promotion content, use traditional form submission
        formElement.submit();
        return;
    }
    
    // Cross-promotion exists, use Ajax submission
    const crossPromotionModal = new CrossPromotionModal();
    const formData = new FormData(formElement);
    const originalButtonText = submitButton ? submitButton.innerHTML : '';
    
    // Double-check qty field is included (shouldn't be needed with readonly, but kept for safety)
    const qtyField = formElement.querySelector('[name="qty"]');
    if (qtyField && qtyField.value && !formData.has('qty')) {
        formData.append('qty', qtyField.value);
    }
    
    // Send Ajax request
    fetch('/cart-ajax/add', {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        if (data.success) {
            // Reset form state before showing modal
            if (submitButton) {
                submitButton.innerHTML = originalButtonText;
                submitButton.removeAttribute('disabled');
                Css.removeClass(submitButton, 'loading');
                Css.removeClass(submitButton, 'loading--center');
                Css.removeClass(submitButton, 'loading--no-style');
            }
            if (qtyInput) {
                qtyInput.removeAttribute('readonly');
                qtyInput.style.opacity = '';
                qtyInput.style.cursor = '';
            }
            
            // Show cross-promotion modal
            const modalOpened = crossPromotionModal.open(crossPromotionContent, function() {
                // When modal closes without action, redirect to cart
                window.location.href = data.cartUrl || '/cart';
            });
            
            // If modal wasn't opened (already shown this session), redirect to cart immediately
            if (!modalOpened) {
                window.location.href = data.cartUrl || '/cart';
            }
        } else {
            // Handle errors
            console.error('Error adding to cart:', data.errors);
            
            // Reset form state
            if (submitButton) {
                submitButton.innerHTML = originalButtonText;
                submitButton.removeAttribute('disabled');
                Css.removeClass(submitButton, 'loading');
                Css.removeClass(submitButton, 'loading--center');
                Css.removeClass(submitButton, 'loading--no-style');
            }
            if (qtyInput) {
                qtyInput.removeAttribute('readonly');
                qtyInput.style.opacity = '';
                qtyInput.style.cursor = '';
            }
            
            // Show error message
            alert('Error adding product to cart. Please try again.');
        }
    })
    .catch(error => {
        // Reset form state
        if (submitButton) {
            submitButton.innerHTML = originalButtonText;
            submitButton.removeAttribute('disabled');
            Css.removeClass(submitButton, 'loading');
            Css.removeClass(submitButton, 'loading--center');
            Css.removeClass(submitButton, 'loading--no-style');
        }
        if (qtyInput) {
            qtyInput.removeAttribute('disabled');
        }
        
        // Fallback to regular form submission
        formElement.submit();
    });
};

export default addToCart;